<div class="cliente-analise-mercado-header">
    <!-- Central de Compras -->
    <ng-template [ngIf]="isCentralCompras()">
        <sgt-cliente-central-compra
            [idClienteCentralCompra]="idCliente"
            [showParticipantes]="showParticipantesCentralCompras">
        </sgt-cliente-central-compra>
    </ng-template>

    <!-- Cliente -->
    <ng-template [ngIf]="!isCentralCompras()">
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Cliente</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{codigoIntegracaoErpCliente}}</span>
                    </div> 
                    <input type="text" class="form-control" [value]="nomeCliente" disabled="disabled" readonly="readonly">                           
                </div>
                <p class="form-text text-muted">
                    {{nomeFantasiaCliente}} - {{cnpjCpfCliente}} - {{nomeCidadeCliente}} - {{ufCliente}}
                </p> 
                <!-- <div *ngIf="clienteCentralCompra" class="alert alert-info arrow-top-left mt-3 mb-0">
                    <i class="fas fa-info"></i> Análise de mercado da central de compras
                </div>                                                -->
            </div>
        </div>
    </ng-template>

    <div class="row" *ngIf="showRepresentante && !isRepresentante">
        <div class="form-group col-12">
            <label class="col-form-label">Representante</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{codigoIntegracaoErpRepresentante}}</span>
                </div> 
                <input type="text" class="form-control" [value]="nomeRepresentante" disabled="disabled" readonly="readonly">                           
            </div>
            <p class="form-text text-muted">
                {{nomeFantasiaRepresentante}}
            </p>                        
        </div>
    </div>    
    
    <div class="row" *ngIf="showAno">
        <div class="form-group col-12 col-sm-3">
            <label class="col-form-label">Ano</label>
            <input type="text" class="form-control" [value]="ano" disabled="disabled" readonly="readonly">                      
        </div>
    </div> 

    <!-- <div class="row" *ngIf="showClassificacaoFaturamentoPretendida">
        <div class="form-group col-12">
            <label class="col-form-label">Classificação de Faturamento Pretendida</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{codigoClassificacaoFaturamentoPretendida}}</span>
                </div>
                <input type="text" class="form-control" [value]="nomeClassificacaoFaturamentoPretendida" disabled="disabled" readonly="readonly">
            </div>
        </div>
    </div> -->
</div>